import React, { useContext } from 'react';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';

interface ViewResultsButtonProps {
  isListerDisabled: boolean;
  facetsDisplayHandler: () => void;
  noResults: boolean;
}

function ViewResultsButton({
  isListerDisabled,
  facetsDisplayHandler,
  noResults
}: ViewResultsButtonProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  const messages = {
    default: formattedMessage({ id: 'rolex.plp.viewResultsButton', fallback: 'View results' }),
    empty: formattedMessage({ id: 'rolex.plp.search.noResults.titleShort', fallback: 'No Result' })
  };

  return (
    <button
      type="button"
      disabled={isListerDisabled || noResults}
      onClick={facetsDisplayHandler}
      className="rolex-button rolex-button--filled"
    >
      {noResults ? messages.empty : messages.default}
    </button>
  );
}

export default ViewResultsButton;
